// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__lthlR","notes":"Notes_notes__19285","note":"Notes_note___uY-x","markdown":"Notes_markdown__FTmiM"};